export enum StoredItems {
    Language = 'be6034a44fb445929b0f9e651fa35ebe',
    AppPreferredSettings = '3e647f78779d4d2bbb3ebe96e68b53e1',
    LoggedOnUser = '3b30270346164b5ca0f62b9858434b44',
    CognitoUser = 'aeff90a4b7bc45cea97db339159d7bf3',
    OrganizationIdentifier = 'be1f6af805ae42eb90e3e89b17fa644f',
    OrganizationSource = 'efe327f22fac4348bf033eb79fa0f41b',
    OrganizationInformation = '9c7e4b1d77cb4fdda616dd0fc1daee83',
    Route = 'f71abe5796064b4ab665b2e5c7486edb',    
}

